module.exports = __webpack_public_path__ + "static/media/Rating.5522dbec.svg";